import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function BannerSlider({ banners }) {
  const [idx, setIdx] = useState(0);
  const list = banners || [];

  useEffect(() => {
    if (list.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % list.length), 5000);
    return () => clearInterval(t);
  }, [list.length]);

  if (list.length === 0) return null;
  const b = list[idx];
  const go = (href) => {
    if (href?.startsWith("#")) document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="banner-slider" className="relative pt-[74px]">
      <div className="relative h-[280px] sm:h-[360px] overflow-hidden">
        <img src={b.image} alt={b.heading} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[var(--c-primary)]" style={{ opacity: parseFloat(b.overlay) || 0.4 }} />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 h-full flex flex-col justify-center text-white">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold max-w-2xl">{b.heading}</h2>
          {b.subheading && <p className="font-body text-lg mt-3 max-w-xl text-white/85">{b.subheading}</p>}
          {b.buttonLabel && (
            <button onClick={() => go(b.buttonHref)} className="mt-6 self-start rounded-full bg-[var(--c-accent)] text-white font-body font-medium px-7 py-3 hover:bg-white hover:text-[var(--c-primary)] transition-colors">
              {b.buttonLabel}
            </button>
          )}
        </div>
        {list.length > 1 && (
          <>
            <button onClick={() => setIdx((i) => (i - 1 + list.length) % list.length)} className="absolute left-4 top-1/2 -translate-y-1/2 grid place-items-center h-10 w-10 rounded-full bg-white/20 backdrop-blur text-white hover:bg-white/30"><ChevronLeft className="h-5 w-5" /></button>
            <button onClick={() => setIdx((i) => (i + 1) % list.length)} className="absolute right-4 top-1/2 -translate-y-1/2 grid place-items-center h-10 w-10 rounded-full bg-white/20 backdrop-blur text-white hover:bg-white/30"><ChevronRight className="h-5 w-5" /></button>
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
              {list.map((_, i) => <button key={i} onClick={() => setIdx(i)} className={`h-2 rounded-full transition-all ${i === idx ? "w-6 bg-white" : "w-2 bg-white/50"}`} />)}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
